import { InjectionToken, inject } from '@angular/core';
import { IQueueStore } from './queue.public';
import { QueueStore } from './queue.store';

export const QUEUE_STORE = new InjectionToken<IQueueStore>('QUEUE_STORE', {
    providedIn: 'root',
    factory: () => inject(QueueStore) as IQueueStore,
});
